import script from "./config-detail.vue?vue&type=script&setup=true&lang=tsx"
export * from "./config-detail.vue?vue&type=script&setup=true&lang=tsx"

import "./config-detail.vue?vue&type=style&index=0&id=6031781e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6031781e"]])

export default __exports__